module.exports = __webpack_public_path__ + "img/thee2-home.2f75a0fb.jpg";